export const appConfig = {
    resourceTypes: {
        code: 'code',
        site: 'site',
        area: 'area',
        project: 'project',
        feature: 'feature',
        featureType: 'featuretype',
        observation: 'observation',
    },
    maxFileUploadSize: 200 * 1024 * 1024, // 200MB
};
